var map = {
	"./baby-notebook__box-d-day--One01.png": 59657,
	"./baby-notebook__box-d-day--One02.png": 68946,
	"./baby-notebook__box-d-day--One03.png": 66811,
	"./baby-notebook__box-d-day--One04.png": 85156,
	"./baby-notebook__box-d-day--One05.png": 41453,
	"./baby-notebook__box-d-day--One06.png": 59830,
	"./baby-notebook__box-d-day--One07.png": 39807,
	"./baby-notebook__box-d-day--One08.png": 57544,
	"./baby-notebook__box-d-day--One09.png": 71761,
	"./baby-notebook__box-d-day--One10.png": 62731
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6797;